function t(){return{top:0,right:0,bottom:0,left:0}}export{t as default};
//# sourceMappingURL=getFreshSideObject.js.map
